import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormField, MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { ItemPrice, PromotionItemPrice } from '@idealsupply/products-api-angular-client';
import { ProductUnitLabels } from 'products-data';
import { ItemPriceViewComponent } from 'products-ui';

@Component({
  selector: 'ideal-price-component-tests-page',
  standalone: true,
  imports: [ItemPriceViewComponent, MatCheckboxModule, MatRadioModule, MatSliderModule, NgTemplateOutlet, MatSelectModule, MatFormField],
  templateUrl: './price-component-tests.component.html',
  styleUrl: './price-component-tests.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceComponentTestsPageComponent {
  // protected callForPrice = {
  //   ...defaultItemPriceViewModel,
  //   isCallForPricing: true,
  // } as ItemPriceViewModel;
  // protected basicPrice = {
  //   ...defaultItemPriceViewModel,
  //   hasPrice: true,
  //   pricePerUnit: 24.99,
  //   pricePerSoldIn: 24.99,
  //   pricePerUnitRegular: 24.99,
  //   pricePerSoldInRegular: 24.99,
  // } as ItemPriceViewModel;
  // protected basicSellMultiplePrice = {
  //   ...this.basicPrice,
  //   quantitySoldIn: 5,
  //   pricePerSoldIn: this.basicPrice.pricePerUnit! * 5,
  //   pricePerSoldInRegular: this.basicPrice.pricePerUnitRegular! * 5,
  // } as ItemPriceViewModel;
  // protected basicContainerQuantityPrice = {
  //   ...this.basicPrice,
  //   quantityPerContainer: 10,
  //   pricePerContainer: this.basicPrice.pricePerUnit! * 10,
  //   pricePerContainerRegular: this.basicPrice.pricePerUnitRegular! * 10,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected highPrice = {
  //   ...defaultItemPriceViewModel,
  //   hasPrice: true,
  //   pricePerUnit: 999.99,
  //   pricePerSoldIn: 999.99,
  //   pricePerUnitRegular: 1299.99,
  //   pricePerSoldInRegular: 1299.99,
  //   quantityPerContainer: 10000,
  //   pricePerContainer: 9999900.0,
  //   pricePerContainerRegular: 12999900.0,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected basicContainerQuantityAndSellMultiplePrice = {
  //   ...this.basicSellMultiplePrice,
  //   quantityPerContainer: 10,
  //   pricePerContainer: this.basicPrice.pricePerUnit! * 10,
  //   pricePerContainerRegular: this.basicPrice.pricePerUnitRegular! * 10,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected basicByContainerPrice = {
  //   ...this.basicSellMultiplePrice,
  //   quantityPerContainer: 5,
  //   pricePerContainer: this.basicPrice.pricePerUnit! * 5,
  //   pricePerContainerRegular: this.basicPrice.pricePerUnitRegular! * 5,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected basicByMultiContainerPrice = {
  //   ...this.basicSellMultiplePrice,
  //   quantitySoldIn: 10,
  //   pricePerSoldIn: this.basicPrice.pricePerUnit! * 10,
  //   pricePerSoldInRegular: this.basicPrice.pricePerUnitRegular! * 10,
  //   quantityPerContainer: 5,
  //   pricePerContainer: this.basicPrice.pricePerUnit! * 5,
  //   pricePerContainerRegular: this.basicPrice.pricePerUnitRegular! * 5,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected inputUserPricePerNoContainerQuantityPrice = {
  //   ...this.basicPrice,
  // } as ItemPriceViewModel;
  // protected inputUserPricePerPrice = {
  //   ...this.basicPrice,
  //   quantityPerContainer: 10,
  //   pricePerContainer: this.basicPrice.pricePerUnit! * 10,
  //   pricePerContainerRegular: this.basicPrice.pricePerUnitRegular! * 10,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
  // protected basicSalePrice = {
  //   ...this.basicPrice,
  //   isOnSale: true,
  //   pricePerUnit: 19.99,
  //   pricePerSoldIn: 19.99,
  // } as ItemPriceViewModel;
  // protected basicLimitedSalePrice = {
  //   ...this.basicSalePrice,
  //   isOnSaleLimited: true,
  //   sale: {
  //     type: 'promotion',
  //     promotionId: '',
  //     branch: '',
  //     promotionName: 'Summer Sale',
  //     effectiveDate: new Date().toISOString(),
  //     expiryDate: new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000).toISOString(),
  //     price: 19.99,
  //     pricePer: 1,
  //     unitPrice: 19.99,
  //   } as PromotionItemPrice as unknown as ItemPrice,
  // } as ItemPriceViewModel;
  // protected sellMultiplePrice = {
  //   ...this.basicLimitedSalePrice,
  //   quantitySoldIn: 5,
  //   pricePerSoldIn: this.basicLimitedSalePrice.pricePerUnit! * 5,
  //   pricePerSoldInRegular: this.basicLimitedSalePrice.pricePerUnitRegular! * 5,
  // } as ItemPriceViewModel;
  // protected sellMultipleMeterPrice = {
  //   ...this.sellMultiplePrice,
  //   unitLabelLocalized: ProductUnitLabels.mr,
  // } as ItemPriceViewModel;
  // protected containerQuantityPrice = {
  //   ...this.basicLimitedSalePrice,
  //   quantityPerContainer: 10,
  //   pricePerContainer: this.basicLimitedSalePrice.pricePerUnit! * 10,
  //   pricePerContainerRegular: this.basicLimitedSalePrice.pricePerUnitRegular! * 10,
  //   hasContainer: true,
  // } as ItemPriceViewModel;
}
